module.exports = __webpack_public_path__ + "static/015.thumb-2083ee62b519e6a8effb16e6637836ce.jpg";